import { lazy, type ComponentType, type LazyExoticComponent } from "react";

type ModuleLoader<TProps extends object, T extends ComponentType<TProps>> = () => Promise<{ default: T }>;

const isChunkLoadFailure = (error: unknown): boolean => {
  const message = error instanceof Error ? error.message : String(error);
  const normalized = message.toLowerCase();

  return normalized.includes("failed to fetch dynamically imported module")
    || normalized.includes("importing a module script failed")
    || normalized.includes("chunkloaderror")
    || normalized.includes("loading chunk");
};

export const lazyWithRetry = <TProps extends object, T extends ComponentType<TProps>>(
  retryKey: string,
  importer: ModuleLoader<TProps, T>,
): LazyExoticComponent<T> =>
  lazy(async () => {
    try {
      const module = await importer();
      sessionStorage.removeItem(retryKey);
      return module;
    } catch (error) {
      if (typeof window !== "undefined" && isChunkLoadFailure(error) && !sessionStorage.getItem(retryKey)) {
        sessionStorage.setItem(retryKey, "1");
        window.location.reload();
        await new Promise(() => {});
      }

      sessionStorage.removeItem(retryKey);
      throw error;
    }
  });
